export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/2e1573d7eabc-tooliconnumber4.jpg',
  },
  title: 'What is your booking reference?',
}
